import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=5d51aa72&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=5d51aa72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51aa72",
  null
  
)

export default component.exports